import { render, staticRenderFns } from "./Barrage.vue?vue&type=template&id=a8cc8a5a&scoped=true"
import script from "./Barrage.vue?vue&type=script&lang=js"
export * from "./Barrage.vue?vue&type=script&lang=js"
import style0 from "./Barrage.vue?vue&type=style&index=0&id=a8cc8a5a&prod&lang=css"
import style1 from "./Barrage.vue?vue&type=style&index=1&id=a8cc8a5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cc8a5a",
  null
  
)

export default component.exports